import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../../../axiosInterceptor";
import Loader from "../../../Components/Loader";
import OrderSummary from ".././OrderSummary";
import UserDetail from "./components/userDetail";
import PaymentCard from "./components/paymentCard";
import DispatchItem from "./components/dispatch/dispatchItem";
import PriceSummary from "./components/priceSummary";
import OrderPaymentStatusCard from "./components/dispatch/OrderPaymentStatusCard";
import StatusBadge from "../../../Components/StatusBadge";

const OrderDetailPage = () => {
 const { id } = useParams();
 const [Invocedata, setInvocedata] = useState({});
 const [loading, setLoading] = useState(true);
 const fetchOrderDetail = async (id) => {
  try {
   const response = await axiosInstance.get(`/customer/order/details/${id}`);
   if (response.status === 200) {
    setInvocedata(response.data?.data);
   }
  } catch (error) {
   toast.error(error.response?.data?.message || "Something went wrong");
  } finally {
   setLoading(false);
  }
 };
 useEffect(() => {
  fetchOrderDetail(id);
 }, [id]);

 if (loading) {
  return <Loader />;
 }

 return (
  <div className="content-wrapper">
   <div className="page-header mt-5">
    <h3 className="custom-page-title">Order Details</h3>
   </div>
   <div className="row  grid-margin stretch-card">
    <div className="col-md-6 grid-margin">
     <div>
      <div className="card rounded-3 shadow-sm">
       <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
         <div>
          <h6>
           Order No: <span className="text-danger">{Invocedata?.orderId}</span>
          </h6>
          <p>Currency Code: {Invocedata?.currency}</p>
         </div>
         <div>
          <StatusBadge status={Invocedata?.status} />
         </div>
        </div>
        {/* <div className="d-flex justify-content-between" style={{ gap: "10px" }}>
         <Link to={`/invoice/${id}`} className="btn btn-outline-dark btn-sm">
          <i className="fa-solid fa-file-invoice me-1"></i> View Invoice
         </Link>
        </div> */}
        <hr className="my-3 border-2 border-dark" />
        <div style={{ height: "180px", overflow: "auto" }}>
         <OrderSummary
          orderdetails={Invocedata}
          id={id}
          Invocedata={Invocedata}
         />
        </div>
       </div>
      </div>
     </div>
     <div style={{ marginTop: "20px" }}>
      <PaymentCard payment={Invocedata?.payment?.[0]} />
     </div>
    </div>
    <div className="col-md-6 grid-margin">
     <UserDetail Invocedata={Invocedata} />
     <PriceSummary
      subtotal={Invocedata?.subtotal}
      discount={Invocedata?.discount}
      tax={Invocedata?.Tax}
      shipping={Invocedata?.shippingcharge}
      handling={Invocedata?.handlingcharge}
      totalAmount={Invocedata?.totalAmount}
      state={Invocedata?.shippingAddress?.state}
     />
    </div>

    <div className="col-md-12">
     <div className="row">
      <DispatchItem id={Invocedata.orderId} />
     </div>
    </div>

    <OrderPaymentStatusCard
     orderId={Invocedata.orderId}
     currentOrderStatus={Invocedata?.status}
     currentPaymentStatus={Invocedata?.payment?.[0]?.status}
     fetchOrderDetail={fetchOrderDetail}
     data={Invocedata}
    />
   </div>
  </div>
 );
};

export default OrderDetailPage;
